"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.symbol.description.js");
var _react = _interopRequireDefault(require("react"));
var _SVBTypography = require("../../SVBTypography");
var _SVBBreadCrumb = require("../../SVBBreadCrumb");
const _excluded = ["title", "description", "image"];
/**
 * Global components
 * By Bhargav Shivaprasad <bshivaprasad@svb.com> (www.svb.com)
 * Summary
 * This component renders an SVB Slogan
 */
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/**
 * SVBSlogans
 * @param sloganContent: strings like title, description and image
 * see ../readme.MD for sample body
 * @param title: slogan title
 * @param description: slogan description
 * @param image: image for the slogan
 * @param extraClasses: additional classes if any to apply
 * @returns slogan HTML with content
 */
const SVBSlogans = _ref => {
  let {
      title,
      description,
      image
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const extraClasses = props.extraClasses || '';
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "slogan d-flex ".concat(extraClasses)
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (props === null || props === void 0 ? void 0 : props.breadCrumbs) && /*#__PURE__*/_react.default.createElement(_SVBBreadCrumb.SVBBreadCrumb, {
    breadCrumbs: props === null || props === void 0 ? void 0 : props.breadCrumbs,
    extraClasses: true
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "slogan-text"
  }, title && /*#__PURE__*/_react.default.createElement(_SVBTypography.SVBTypography, {
    type: "heading-xlarge"
  }, title), description && /*#__PURE__*/_react.default.createElement(_SVBTypography.SVBTypography, {
    type: "sub-heading-large"
  }, description))), /*#__PURE__*/_react.default.createElement("div", {
    className: "slogan-img"
  }, image && /*#__PURE__*/_react.default.createElement("img", {
    src: image,
    alt: "logo"
  })));
};
var _default = SVBSlogans;
exports.default = _default;